module.exports = {
  linkedIn: {
    CLIENT_ID: "78sh5xvxx3g753",
    REDIRECT_URL: `${window.location.origin}/login`
  }, 
  api: {
    API_URL: "https://asia-south2-codedplus-25.cloudfunctions.net", // Prod
    // API_URL: "http://127.0.0.1:5001/codedplus-25/asia-south2", // Dev
    SOCKET_URL: "https://coded-plus.el.r.appspot.com",
    AGORA_URL: "https://agora-test-sdk--testing-12pptmqi.web.app/whiteboard.js",
    ENVIRONMENT: "Dev"
  }
};
